module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/jPXIUw/tc-custom/9780830894697.jpg?1696025388616",
      "alt": "This image is the cover for the book Numbers, Tyndale Old Testament Commentaries"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Numbers, Tyndale Old Testament Commentaries\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("\"Guide me, O Thou Great Jehovah\" is one of the best-known hymns in the world. Yet the book of numbers, whose story that hymn summarizes, is seldom read. Why? \"Its very title puts the modern reader off,\" writes Gordon Wenham. \"In ancient time numbers were seen as mysterious and symbolic, a key to reality and the mind of God himself. Today they are associated with computers and the depersonalization that threatens our society.\" In his effort to bridge the great gulf between the book and our age, Wenham first explains the background of Numbers, discussing its structure, sources, date and authorship as well as its theology and Christian use. A passage-by-passage analysis follows, which draws useful insights on Old Testament ritual from modern social anthropology. The original, unrevised text of this volume has been completely retypeset and printed in a larger, more attractive format with the new cover design for the series.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Gordon J. Wenham\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', [_vm._v("Gordon J. Wenham is lecturer in Old Testament at Trinity College, Bristol. He was formerly professor of Old Testament at the University of Gloucestershire. He is a recognized expert on the Pentateuch and has written commentaries on Genesis, Leviticus and Numbers in addition to numerous studies in the Old Testament.")]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    InterVarsity Christian\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0